<template>
  <div>
    <base-title
      title="API de Conversões do Facebook"
      :subtitle="StringLanguage.integrations"
      link="integracoes"
    />

    <div class="integration-details">
      <div class="header">
        <div class="wrapper">
          <p class="title">Sobre a API de Conversões do Facebook</p>
          <img
            src="@/assets/img/integration.svg"
            class="img-fluid mobile"
            alt="Integrações"
          />
          <p class="description">
            A API de Conversões do Facebook é uma ferramenta analítica que o
            Facebook disponibiliza para ajudar a mensurar o sucesso de uma
            campanha patrocinada a partir de um código inserido em cada página
            de seu site.
          </p>
        </div>
        <img
          src="@/assets/img/integration.svg"
          class="img-fluid desktop"
          alt="Integrações"
        />
      </div>

      <div class="register">
        <base-button
          text="Cadastrar"
          class="big w-100"
          @click="changeRoute('cadastro-facebook-pixel')"
        />

        <div class="help">
          <p>Tem dúvidas? Acesse&nbsp;</p>
          <a
            href="https://ajuda.easydelivery.com.br/apis-e-integracoes/como-configurar-a-api-de-conversoes-do-facebook-antigo-pixel"
            target="_blank"
            class="link"
            >https://ajuda.easydelivery.com.br/</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@/assets/css/veasy/integrations.css';

import BaseTitle from '@/components/Title';
import BaseButton from '@/components/Button';
import StoreAPI from '../../../api/store';

export default {
  components: {
    BaseTitle,
    BaseButton,
  },
  methods: {
    async changeRoute(routeName) {
      const checkDomains = await StoreAPI.getDomains();
      if (!Array.isArray(checkDomains.getData())) {
        alert(
          'É necessário configurar um domínio proprio na sua loja, para utilizar este recurso.'
        );
        return '';
      }
      this.$router.push({ name: routeName });
    },
  },
};
</script>
